var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "#6851FF",
    fillOpacity: 1,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51916 17.6847H3.34248V8.18079H0.608481C0.271318 8.18079 0 7.93398 0 7.62762V6.10928C0 5.87448 0.161907 5.67344 0.387502 5.5939L9.98405 1.05301C11 0.499639 11.5 0.500427 12.5051 1.05301L22.1389 5.60997C22.2791 5.67568 22.487 5.88663 22.487 6.10942V7.62777C22.487 7.93428 22.2155 8.18093 21.8806 8.18093H19.1445V17.6849H20.9678C21.3027 17.6849 21.5763 17.9317 21.5763 18.2361V20.4468C21.5763 20.7512 21.3027 21 20.9678 21H1.51907C1.18421 21 0.910587 20.7512 0.910587 20.4468V18.2361C0.910587 17.9317 1.18431 17.6847 1.51916 17.6847ZM6.98912 8.18079V17.6847H9.42092V8.18079H6.98912ZM13.0676 8.18079V17.6847H15.4973V8.18079H13.0676Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.6c4b47c988616c56f197a5bc6215927a.svg";
export { ForwardRef as ReactComponent };